var _defs, _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ae6acf03-6733-41b0-a229-6576c96af2d5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-58ba1c09-e2d1-42b0-a7d8-d9923db615be",
    x1: 192.15,
    y1: 43.77,
    x2: 194.53,
    y2: 41.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4aaaf5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m193.34,44.37c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z",
    fill: "url(#uuid-58ba1c09-e2d1-42b0-a7d8-d9923db615be)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 541,
    width: 302,
    height: 70,
    rx: 30.72,
    ry: 30.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 676.5,
    width: 392,
    height: 70,
    rx: 35,
    ry: 35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m167.72,812h240.56c16.96,0,30.72,13.77,30.72,30.72v8.56c0,16.96-13.77,30.72-30.72,30.72h-240.56c-16.96,0-30.72-13.77-30.72-30.72v-8.56c0-16.96,13.77-30.72,30.72-30.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1052.68,155.08l-99.33-105.89c-14.38-15.33-33.91-24.1-54.98-24.69-20.97-.59-40.98,7.02-56.32,21.41l-215.44,202.09H95.76c-41.78,0-75.65,33.87-75.65,75.65v670.7c0,41.78,33.87,75.65,75.65,75.65h625.29c41.78,0,75.65-33.87,75.65-75.65v-491.49l252.13-236.51c31.74-29.77,33.47-79.69,3.84-111.28Zm-326.52,794.29c0,21.56-17.47,39.03-39.03,39.03H129.68c-21.56,0-39.03-17.47-39.03-39.03V434.47h399.45l-8.53,74.88c-2.61,22.94,4.92,45.73,20.67,62.52,14.86,15.84,35.5,24.72,57.15,24.72,1.3,0,2.61-.03,3.92-.1l112.02-5.55c18.7-.93,36.54-8.51,50.23-21.35l.59-.56v380.33ZM1007.79,222.59l-211.08,198-70.54,66.17-41.64,39.06c-3.32,3.12-7.63,4.96-12.14,5.18l-112.02,5.55c-7.45.37-12.18-3.44-14.34-5.75-2.16-2.3-5.66-7.27-4.82-14.68l9.3-81.67,3.39-29.77c.51-4.49,2.62-8.67,5.94-11.79l154.48-144.91,168.79-158.33c3.59-3.37,8.21-5.2,13.06-5.2.18,0,.36,0,.54,0,4.96.14,9.53,2.18,12.89,5.76l99.33,105.89c6.99,7.45,6.49,19.33-1.13,26.47Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.3c0352d49aa3558488911e6a5d53f6b5.svg";
export { ForwardRef as ReactComponent };